import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

class SiderBarItem extends React.Component {
  render() {
    const { item, click, secondLevel } = this.props;
    const badgeClass = item.badge ? "nav-item-badge" : "";
    const secondLevelClass = secondLevel ? "nav-item-main-second" : "";
    const arrowImageSrc = require(item.open
      ? "@/assets/images/menu-arrow-up.svg"
      : "@/assets/images/menu-arrow-down.svg");
    return (
      <div
        className={`nav-item ${item.active && item.path ? "nav-active" : ""} ${
          item.disabled ? "nav-disabled" : ""
        }`}
        onClick={click}
        tabIndex={(!!item.path || item.disabled) ? "-1" : "0"}
      >
        {item.path ? (
          <RouterLink
            className={`flex-row-vertical-center match-parent nav-item-main justify-content-between ${badgeClass} ${secondLevelClass}`}
            to={item.path}
            tabIndex={item.disabled ? "-1" : "0"}
          >
            <div>
              {item.imageSrc && (
                <img
                  className="nav-item-icon"
                  src={item.active ? item.selectedImageSrc : item.imageSrc}
                  alt=""
                />
              )}
              <span>{item.name}</span>
            </div>
            <span className="nav-badge-dot" />
          </RouterLink>
        ) : (
          <div
            className={`flex-row-vertical-center match-parent nav-item-main justify-content-between ${badgeClass} ${secondLevelClass}`}
          >
            <span>{item.name}</span>
            <img className="nav-item-arrow" src={arrowImageSrc} alt="" />
          </div>
        )}
      </div>
    );
  }
}

SiderBarItem.propTypes = {
  item: PropTypes.shape({
    active: PropTypes.bool,
    badge: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
    path: PropTypes.string,
    imageSrc: PropTypes.any,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }).isRequired,
  click: PropTypes.func,
  secondLevel: PropTypes.bool,
};

SiderBarItem.defaultProps = {
  click: undefined,
  secondLevel: false,
};

export default SiderBarItem;
